import React, { useState, useEffect } from 'react';
import { IPhoneMockup } from 'react-device-mockup';
import { websiteAPI } from '../../api/api';
import './SocialContent.css';

// Иконки социальных сетей
const TelegramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0169 0.117465C18.264 0.013456 18.5345 -0.022416 18.8002 0.0135823C19.0659 0.0495806 19.317 0.156133 19.5276 0.32215C19.7381 0.488167 19.9003 0.707579 19.9973 0.957548C20.0942 1.20752 20.1224 1.47891 20.0789 1.74347L17.8109 15.5005C17.5909 16.8275 16.1349 17.5885 14.9179 16.9275C13.8999 16.3745 12.3879 15.5225 11.0279 14.6335C10.3479 14.1885 8.26489 12.7635 8.52089 11.7495C8.74089 10.8825 12.2409 7.62446 14.2409 5.68747C15.0259 4.92647 14.6679 4.48747 13.7409 5.18747C11.4389 6.92547 7.74289 9.56847 6.52089 10.3125C5.44289 10.9685 4.88089 11.0805 4.20889 10.9685C2.98289 10.7645 1.84589 10.4485 0.917888 10.0635C-0.336112 9.54347 -0.275112 7.81947 0.916888 7.31747L18.0169 0.117465Z" fill="white"/>
  </svg>
);

// Иконка Telegram для декоративного квадрата (цветная)
const TelegramIconColored = ({ color = '#36acf2' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M29.666 6.64495C30.0366 6.48893 30.4424 6.43513 30.8409 6.48912C31.2394 6.54312 31.6162 6.70295 31.932 6.95198C32.2478 7.201 32.4911 7.53012 32.6365 7.90507C32.7819 8.28003 32.8242 8.68711 32.759 9.08395L29.357 29.7194C29.027 31.7099 26.843 32.8514 25.0175 31.8599C23.4905 31.0304 21.2225 29.7524 19.1825 28.4189C18.1625 27.7514 15.038 25.6139 15.422 24.0929C15.752 22.7924 21.002 17.9054 24.002 14.9999C25.1795 13.8584 24.6425 13.1999 23.252 14.2499C19.799 16.8569 14.255 20.8214 12.422 21.9374C10.805 22.9214 9.96196 23.0894 8.95396 22.9214C7.11496 22.6154 5.40946 22.1414 4.01746 21.5639C2.13646 20.7839 2.22796 18.1979 4.01596 17.4449L29.666 6.64495Z" fill="#36ACF2"/>
  </svg>
);

const VKIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M4.97 4.97C3.5 6.454 3.5 8.827 3.5 13.58V14.42C3.5 19.166 3.5 21.539 4.97 23.03C6.454 24.5 8.827 24.5 13.58 24.5H14.42C19.166 24.5 21.539 24.5 23.03 23.03C24.5 21.546 24.5 19.173 24.5 14.42V13.58C24.5 8.834 24.5 6.461 23.03 4.97C21.546 3.5 19.173 3.5 14.42 3.5H13.58C8.834 3.5 6.461 3.5 4.97 4.97ZM7.042 9.891H9.45C9.527 13.895 11.291 15.589 12.691 15.939V9.891H14.952V13.342C16.331 13.195 17.787 11.62 18.277 9.884H20.531C20.3471 10.7826 19.9799 11.6336 19.4524 12.3839C18.9249 13.1343 18.2483 13.7678 17.465 14.245C18.3393 14.68 19.1115 15.2955 19.7305 16.0509C20.3495 16.8062 20.8013 17.6842 21.056 18.627H18.571C18.039 16.968 16.709 15.68 14.952 15.505V18.627H14.672C9.884 18.627 7.154 15.351 7.042 9.891Z" fill="white"/>
  </svg>
);

// Цветная иконка VK для декоративного квадрата
const VKIconColored = ({ color = '#0079ff' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path d="M2.1 2.1C3.97364e-07 4.22 0 7.61 0 14.4V15.6C0 22.38 3.97364e-07 25.77 2.1 27.9C4.22 30 7.61 30 14.4 30H15.6C22.38 30 25.77 30 27.9 27.9C30 25.78 30 22.39 30 15.6V14.4C30 7.62 30 4.23 27.9 2.1C25.78 3.97364e-07 22.39 0 15.6 0H14.4C7.62 0 4.23 3.97364e-07 2.1 2.1ZM5.06 9.13H8.5C8.61 14.85 11.13 17.27 13.13 17.77V9.13H16.36V14.06C18.33 13.85 20.41 11.6 21.11 9.12H24.33C24.0673 10.4037 23.5427 11.6194 22.7891 12.6914C22.0355 13.7633 21.069 14.6683 19.95 15.35C21.1991 15.9714 22.3021 16.8507 23.1864 17.9298C24.0707 19.0089 24.7161 20.2632 25.08 21.61H21.53C20.77 19.24 18.87 17.4 16.36 17.15V21.61H15.96C9.12 21.61 5.22 16.93 5.06 9.13Z" fill="#0079FF"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26.4278 2.97778C26.1111 1.78889 25.1722 0.85 23.9833 0.533333C21.8611 0 13.5 0 13.5 0C13.5 0 5.13889 0 3.01667 0.533333C1.82778 0.85 0.888889 1.78889 0.572222 2.97778C0 5.1 0 9.5 0 9.5C0 9.5 0 13.9 0.572222 16.0222C0.888889 17.2111 1.82778 18.15 3.01667 18.4667C5.13889 19 13.5 19 13.5 19C13.5 19 21.8611 19 23.9833 18.4667C25.1722 18.15 26.1111 17.2111 26.4278 16.0222C27 13.9 27 9.5 27 9.5C27 9.5 27 5.1 26.4278 2.97778ZM10.8 13.5556V5.44444L17.8333 9.5L10.8 13.5556Z" fill="white"/>
  </svg>
);

// Цветная иконка YouTube для декоративного квадрата
const YouTubeIconColored = ({ color = '#ff3a3a' }) => (
  <svg width="36" height="25" viewBox="0 0 36 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.2371 3.97037C34.8148 2.38519 33.5629 1.13333 31.9778 0.711111C29.1481 0 18 0 18 0C18 0 6.85185 0 4.02222 0.711111C2.4371 1.13333 1.18519 2.38519 0.762963 3.97037C0 6.8 0 12.6667 0 12.6667C0 12.6667 0 18.5333 0.762963 21.363C1.18519 22.9481 2.4371 24.2 4.02222 24.6222C6.85185 25.3333 18 25.3333 18 25.3333C18 25.3333 29.1481 25.3333 31.9778 24.6222C33.5629 24.2 34.8148 22.9481 35.2371 21.363C36 18.5333 36 12.6667 36 12.6667C36 12.6667 36 6.8 35.2371 3.97037ZM14.4 18.0741V7.25926L23.7778 12.6667L14.4 18.0741Z" fill={color}/>
  </svg>
);

const VcRuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7751 0.391603C20.2697 0.98836 19.173 2.0262 18.4095 3.57748C17.8496 4.71464 17.7482 5.14214 17.7509 6.35613C17.7564 8.78775 19.0016 10.8961 21.1101 12.0436C22.4949 12.7974 24.7597 12.9815 26.3102 12.4664C27.2169 12.1654 29.1963 10.7134 29.1849 10.3579C29.1825 10.2837 28.8294 9.97478 28.4003 9.67133C27.6304 9.12687 27.6154 9.12485 27.2629 9.51424C26.2522 10.6311 23.8024 11.0783 22.3834 10.4049C21.3055 9.8935 20.3591 8.70201 20.0684 7.49025C19.1832 3.80005 22.8174 0.689171 26.2089 2.23437C26.7047 2.46039 26.7568 2.58687 26.7568 3.56654V4.64877H27.7784H28.8002L28.7412 2.99694L28.6824 1.34512L27.4662 0.727278C25.8513 -0.0932622 23.3686 -0.239816 21.7751 0.391603ZM3.24324 1.18539V2.19606L4.39034 2.25687L5.53743 2.31768L7.38385 7.4866L9.23007 12.6555H10.2105H11.191L13.1436 7.43593L15.0963 2.21633H16.0618H17.027V1.19491V0.173495L15.2741 0.232076L13.5209 0.290657L11.9801 4.79897C11.1326 7.27843 10.3936 9.30708 10.3378 9.30687C10.2821 9.30667 9.54466 7.27802 8.69899 4.79856L7.16169 0.290657L5.20236 0.232684L3.24324 0.174711V1.18539ZM4.25676 16.3042V17.2163H5.27027H6.28378V21.4731V25.7298H5.27027H4.25676V26.7434V27.7569H8.91892H13.5811V26.7434V25.7298H10.9459H8.31081V23.2216C8.31081 19.7153 8.9177 18.2519 10.6861 17.4955C11.789 17.0236 11.9595 17.1083 11.9595 18.1285V19.0407H12.973H13.9865V17.2163V15.392H12.9614C11.161 15.392 10.1424 15.7709 9.07662 16.8367L8.10811 17.8052V16.5985V15.392H6.18243H4.25676V16.3042ZM16.4189 16.4055V17.419H17.3311H18.2432V20.7403C18.2432 23.2923 18.3219 24.305 18.5826 25.1122C19.6007 28.2648 23.8058 29.0096 25.8934 26.4071L26.5044 25.6455L26.6495 26.7012L26.7949 27.7569H28.3974H30V26.7434V25.7298H29.1892H28.3784V20.5609V15.392H26.25H24.1216V16.4055V17.419H25.1351H26.1486V20.3955C26.1486 22.9528 26.0919 23.4882 25.7463 24.1962C24.6941 26.3511 21.7095 26.7543 20.8119 24.8627C20.5277 24.2635 20.473 23.4423 20.473 19.7702V15.392H18.4459H16.4189V16.4055ZM0 26.642V27.7569H1.01351H2.02703V26.642V25.5271H1.01351H0V26.642Z" fill="#FFFFFF"/>
  </svg>
);

// Цветная иконка VC.ru для декоративного квадрата
const VcRuIconColored = ({ color = '#000000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.7751 0.391603C20.2697 0.98836 19.173 2.0262 18.4095 3.57748C17.8496 4.71464 17.7482 5.14214 17.7509 6.35613C17.7564 8.78775 19.0016 10.8961 21.1101 12.0436C22.4949 12.7974 24.7597 12.9815 26.3102 12.4664C27.2169 12.1654 29.1963 10.7134 29.1849 10.3579C29.1825 10.2837 28.8294 9.97478 28.4003 9.67133C27.6304 9.12687 27.6154 9.12485 27.2629 9.51424C26.2522 10.6311 23.8024 11.0783 22.3834 10.4049C21.3055 9.8935 20.3591 8.70201 20.0684 7.49025C19.1832 3.80005 22.8174 0.689171 26.2089 2.23437C26.7047 2.46039 26.7568 2.58687 26.7568 3.56654V4.64877H27.7784H28.8002L28.7412 2.99694L28.6824 1.34512L27.4662 0.727278C25.8513 -0.0932622 23.3686 -0.239816 21.7751 0.391603ZM3.24324 1.18539V2.19606L4.39034 2.25687L5.53743 2.31768L7.38385 7.4866L9.23007 12.6555H10.2105H11.191L13.1436 7.43593L15.0963 2.21633H16.0618H17.027V1.19491V0.173495L15.2741 0.232076L13.5209 0.290657L11.9801 4.79897C11.1326 7.27843 10.3936 9.30708 10.3378 9.30687C10.2821 9.30667 9.54466 7.27802 8.69899 4.79856L7.16169 0.290657L5.20236 0.232684L3.24324 0.174711V1.18539ZM4.25676 16.3042V17.2163H5.27027H6.28378V21.4731V25.7298H5.27027H4.25676V26.7434V27.7569H8.91892H13.5811V26.7434V25.7298H10.9459H8.31081V23.2216C8.31081 19.7153 8.9177 18.2519 10.6861 17.4955C11.789 17.0236 11.9595 17.1083 11.9595 18.1285V19.0407H12.973H13.9865V17.2163V15.392H12.9614C11.161 15.392 10.1424 15.7709 9.07662 16.8367L8.10811 17.8052V16.5985V15.392H6.18243H4.25676V16.3042ZM16.4189 16.4055V17.419H17.3311H18.2432V20.7403C18.2432 23.2923 18.3219 24.305 18.5826 25.1122C19.6007 28.2648 23.8058 29.0096 25.8934 26.4071L26.5044 25.6455L26.6495 26.7012L26.7949 27.7569H28.3974H30V26.7434V25.7298H29.1892H28.3784V20.5609V15.392H26.25H24.1216V16.4055V17.419H25.1351H26.1486V20.3955C26.1486 22.9528 26.0919 23.4882 25.7463 24.1962C24.6941 26.3511 21.7095 26.7543 20.8119 24.8627C20.5277 24.2635 20.473 23.4423 20.473 19.7702V15.392H18.4459H16.4189V16.4055ZM0 26.642V27.7569H1.01351H2.02703V26.642V25.5271H1.01351H0V26.642Z" fill="#1C1A1B"/>
  </svg>
);

const ArrowIcon = () => (
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L8.5 8.5L1 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Данные социальных сетей
const socialNetworks = [
  {
    id: 'telegram',
    name: 'Телеграм',
    icon: TelegramIcon,
    coloredIcon: TelegramIconColored,
    color: '#36acf2',
    url: 'https://t.me/GoPlayDonateBot?start=link_1bA3H5VdBJ',
    phoneMockup: '/images/social/telegram-phone.png',
  },
  {
    id: 'vk',
    name: 'Вконтакте',
    icon: VKIcon,
    coloredIcon: VKIconColored,
    color: '#0079ff',
    url: 'https://vk.com/goplaydonate',
    phoneMockup: '/images/social/vk-phone.png',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    icon: YouTubeIcon,
    coloredIcon: YouTubeIconColored,
    color: '#ff3a3a',
    url: 'https://www.youtube.com/@GooglePlayDonateBot/videos',
    phoneMockup: '/images/social/youtube-phone.png',
  },
  {
    id: 'vcru',
    name: 'VC.ru',
    icon: VcRuIcon,
    coloredIcon: VcRuIconColored,
    color: 'rgba(42, 39, 41, 0.5)',
    url: 'https://vc.ru/goplaydonate',
    phoneMockup: '/images/social/vcru-phone.png',
  },
];

// Статистика (начальные значения)
const defaultStats = [
  { value: '92.000+', label: 'Подписчиков' },
  { value: '780.000+', label: 'Заказов' },
  { value: '24/7', label: 'Поддержка' },
  { value: '5+', label: 'Рейтинг' },
];

// Функция форматирования числа
const formatNumber = (num) => {
  if (num >= 1000) {
    // Преобразуем число в строку с разделителем точкой для тысяч
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '+';
  }
  return num.toString() + '+';
};

const SocialContent = ({ 
  networks = socialNetworks,
  statistics,
  onSocialClick 
}) => {
  const [stats, setStats] = useState(statistics || defaultStats);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Загружаем реальную статистику с сервера
    const fetchStats = async () => {
      try {
        const data = await websiteAPI.getStats();
        
        // Обновляем статистику с реальными данными
        setStats([
          { value: formatNumber(data.users_count), label: 'Подписчиков' },
          { value: formatNumber(data.completed_payments_count), label: 'Заказов' },
          { value: '24/7', label: 'Поддержка' },
          { value: '5+', label: 'Рейтинг' },
        ]);
      } catch (error) {
        console.error('Ошибка загрузки статистики:', error);
        // В случае ошибки оставляем значения по умолчанию
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const handleClick = (network) => {
    if (onSocialClick) {
      onSocialClick(network);
    } else {
      window.open(network.url, '_blank');
    }
  };

  return (
    <div className="social-content">
      {/* Карточки социальных сетей */}
      <div className="social-content__cards">
        {networks.map((network) => {
          const IconComponent = network.icon;
          const ColoredIconComponent = network.coloredIcon;
          return (
            <div 
              key={network.id}
              className={`social-content__card social-content__card--${network.id}`}
              style={{ backgroundColor: network.color }}
              onClick={() => handleClick(network)}
            >
              <div className="social-content__card-info">
                <div className="social-content__card-header">
                  <IconComponent />
                  <span className="social-content__card-name">{network.name}</span>
                </div>
                <button className="social-content__card-link">
                  <ArrowIcon />
                  <span>Перейти</span>
                </button>
              </div>
              
              {/* Декоративные элементы справа */}
              <div className="social-content__card-decor">
                {/* Маленький квадрат с иконкой */}
                <div className="social-content__card-icon-box social-content__card-icon-box--small">
                  {ColoredIconComponent && <ColoredIconComponent color={network.color} />}
                </div>
                
                {/* Большой квадрат с иконкой */}
                <div className="social-content__card-icon-box social-content__card-icon-box--large">
                  {ColoredIconComponent && <ColoredIconComponent color={network.color} />}
                </div>
                
                {/* Mockup телефона (iPhone) */}
                {network.phoneMockup && (
                  <div className="social-content__card-phone">
                    <IPhoneMockup
                      screenWidth={120}
                      screenType="island"
                      frameColor="#1a1a1a"
                      hideStatusBar
                    >
                      <img 
                        src={network.phoneMockup} 
                        alt={`${network.name} preview`}
                        style={{ 
                          width: '100%', 
                          height: '100%', 
                          objectFit: 'cover',
                          objectPosition: 'center top'
                        }}
                      />
                    </IPhoneMockup>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Блок информации */}
      <div className="social-content__info">
        <div className="social-content__info-text">
          <h3 className="social-content__info-title">Следите за нашими обновлениям</h3>
          <p className="social-content__info-description">
            Подписывайтесь на наши социальные сети, чтобы быть в курсе последних новостей, обновлений игр и специальных предложений.
          </p>
        </div>
      </div>

      {/* Статистика */}
      <div className="social-content__stats">
        {stats.map((stat, index) => (
          <div key={index} className="social-content__stat">
            <span className="social-content__stat-value">{stat.value}</span>
            <span className="social-content__stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialContent;

